import { render, staticRenderFns } from "./supplierServiceTermsCN.vue?vue&type=template&id=b3fd616e&scoped=true"
import script from "./supplierServiceTermsCN.vue?vue&type=script&lang=js"
export * from "./supplierServiceTermsCN.vue?vue&type=script&lang=js"
import style0 from "./supplierServiceTermsCN.vue?vue&type=style&index=0&id=b3fd616e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3fd616e",
  null
  
)

export default component.exports